import { createSlice } from "@reduxjs/toolkit";

const nudgeSlice = createSlice({
    name: 'nudge',
    initialState: {
        globalNudgeData: null,
    },
    reducers: {
        setGlobalNudgeData: (state, action) => {
            state.globalNudgeData = action.payload;
        }
    }
})

export const { 
    setGlobalNudgeData
} = nudgeSlice.actions

export default nudgeSlice.reducer